import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './StickyBody.less';

export class StickyBody extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired
    };

    render() {
        return (
            <div className="StickyBody full-height">
                {this.props.children}
            </div>
        );
    }
}

export default StickyBody;
